import { CASES } from './constants';

const getInitialReadyProductsSort = () => {
    const saved = localStorage.getItem('readyProductSort');
    return saved ? JSON.parse(saved) : ['productId', 'DESC'];
};

/**
 * Initial state for the readyProducts slice.
 *
 * Key state values:
 * - readyProducts: Array of ready product objects for the grid
 * - totalPages: Total number of pages available based on current filters
 * - totalItems: Total number of items matching current filters
 * - currentPage: Current page number for pagination
 * - filterParam: String used for filtering products by ID or title
 * - readyProductRange: Pagination range string for the API (e.g. "0, 19" from getItemRange)
 * - readyProductSort: Array defining the current sort field and order (e.g., ['productId', 'DESC'])
 * - defaultFilterRange: Default range string, reset when slice is cleared
 * - itemsPerPage: Number of items to display per page in the grid
 * - isModalOpen: Boolean to control visibility of the details modal
 *
 * The state is designed to manage the ready products grid, including pagination, sorting, and filtering.
 * The sort preference is persisted in localStorage to maintain user settings across sessions.

 */
const initialState = {
    readyProducts: [],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    readyProductRange: '0, 19',
    readyProductSort: ['productId', 'DESC'],
    defaultFilterRange: '0, 19',
    itemsPerPage: 20,
    isModalOpen: false,
};

export function readyProducts(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_READY_PRODUCTS: {
            return { ...state, ...payload };
        }
        case CASES.CLEAR_READY_PRODUCTS: {
            return {
                ...initialState,
            };
        }
        default:
            return state;
    }
}
